import React from 'react'
import { LoadingOverlay } from './LoaderElement'
import { CircularProgress } from '@mui/material'

export function Loader({loading, style}) {


  return (
    <>
    { loading ?
      <LoadingOverlay style={style}>
          <CircularProgress thickness={5} sx={{color: '#31BCC0'}}/>
      </LoadingOverlay>
      :
      null
    }
    </>
  )
}
